import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=48070cca&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"
import style0 from "./TabHeader.vue?vue&type=style&index=0&id=48070cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48070cca",
  null
  
)

export default component.exports